import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/PrivacyPolicy.module.css';

interface PrivacyProps extends RouteComponentProps {
    // Define the props here
  }
  interface PrivacyState {
    // Define the state here
  }
class PrivacyPolicy extends React.Component<PrivacyProps, PrivacyState>{
    constructor(props: PrivacyProps) {
        super(props);
    
        this.state = { }
    }


    render(){
        return(
            <IonPage>
            <IonHeader class="ion-no-border">
                <IonToolbar>
                    <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                    <IonTitle>Privacy policy</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <div className="whiteBG">
                    <div className={(styles.privacy)}>
                        <h1>Ons privacybeleid</h1>
    
                        <p>Blij je hier te zien!</p>
                        <p>
                            We zijn ons ervan bewust dat jij vertrouwen stelt in ons en wij respecteren jouw privacy. 
                            Wij zien het dan ook als onze verantwoordelijkheid om jouw privacy te beschermen. 
                            In dit privacybeleid leggen we uit hoe wij omgaan met allerlei data. 
                            We leggen uit welke gegevens we bewaren, hoe we deze verwerken en waarom we dit doen. 
                            Zo krijg je een gedetailleerd inzicht in hoe we werken. 
                            Als je onze App gebruikt, ga je dan ook akkoord met deze voorwaarden.
                        </p>
                        <p>Voor we verder vertellen over ons privacybeleid, willen we kort vertellen over onszelf: </p>
                        <p>
                            WorkerPro Games is een Belgische onderneming geregistreerd in de KBO. 
                            Wij zijn de verantwoordelijke voor het bewaren en verwerken van jouw data. 
                            Dit houdt in dat wij het doel en de middelen van deze verwerkingen bepalen.
                        </p>
                        <p>
                            We bewaren en verwerken jouw persoonsgegevens volgens de bestaande GDPR-regelgeving. 
                            Dit is de EU vordering 2016/697 van het Europees Parlement en de Raad van 27/04/2016 over de bescherming van natuurlijke personen in relatie met de verwerking van persoonsgegevens en het vrije verkeer van die gegevens. 
                            Daarnaast gaat deze regelgeving ook over de intrekking van Richtlijn 95/46/EG met betrekking tot gegevensbescherming.
                        </p>
                        <p>
                            Aangezien in bovenstaande regelgeving specifieke termen worden gebruikt zoals ‘persoonsgegevens’, ‘verwerken’, ‘verwerkingsverantwoordelijke’ en ‘verwerker’, 
                            zullen we in de verdere toelichting van dit privacybeleid dezelfde termen gebruiken.
                        </p>
                        <p>
                            Wij respecteren de privacy van alle gebruikers en garanderen dat we jouw persoonsgegevens confidentieel behandelen en dat we deze bewaren in een optimaal beveiligde omgeving.
                        </p>
                        <p>
                            Wij houden geen persoonsgegevens bij van kinderen onder de 16 jaar. 
                            Dit houdt in dat we ook geen kinderen onder de 16 jaar toelaten op ons platform. 
                            Indien je jonger dan 16 bent, zal je nog geduld moeten uitoefenen. 
                            We vragen je in dit geval om geen Uniplay account te maken of jouw bestaand Uniplay account te verwijderen. 
                        </p>
                        <p>
                            Wanneer je een account aanmaakt in onze App, vragen we je om persoonsgegevens te verstrekken. 
                            Die gegevens worden gebruikt om een account aan te maken in de App en om deel te nemen aan de challenges in de App.
                        </p>
    
                        <h2>Wanneer bewaren we data van jou?</h2>
                        <p>
                            Op het moment dat je onze App downloadt en installeert, wordt al data bewaard. 
                            Daarna gaan we op de volgende momenten data van jouw bewaren: 
                            bij het gebruiken van onze App, bij het koppelen van jouw gegevens met jouw cases en telkens als je meedoet aan een challenge.
                        </p>
    
                        <h2>Wat doen we met de data die we bewaren?</h2>
                        <p>
                            De data die we bewaren gebruiken we voor verschillende doeleinden.
                            We gebruiken persoonsgegevens om een account in de App aan te maken (zoals jouw naam, voornaam en organisatie).
                            Daarnaast bewaren we ook ‘extended data’. 
                            Dit is data die we bekomen door vragen aan jouw te stellen. 
                            Een voorbeeld hiervan zijn de vragen die worden gesteld tijdens een challenge. 
                            Extended data wordt bewaard om onze dienstverlening aan jouw als App gebruiker te verbeteren.
                        </p>
    
                        <h2>Dit doen we vervolgens met die data:</h2>
                        <p>
                            Bovenstaande data gaan we verwerken om je te voorzien van geweldige functionaliteiten in onze App. 
                            Zo gaan we jouw data in statistieken gieten om jouw van inzichten over je voortgang in jouw cases te voorzien. 
                            Daarnaast zullen we ook statistieken uit deze data gebruiken om werkgevers en ondersteunende diensten in jouw organisatie te helpen beter te functioneren.
                        </p>
                        <p>
                            We communiceren meestal via de App om nieuwe en geweldige functionaliteiten aan te kondigen, 
                            maar af en toe kunnen we jouw ook eens een e-mail sturen om in contact te blijven en je op de hoogte te brengen van geweldig nieuws. 
                            Maar we zullen jouw mailbox niet volproppen met nutteloze informatie! 
                            Indien je onze occasionele e-mails toch niet leuk vindt, 
                            kan je je uiteraard uitschrijven voor onze post. 
                            Dit doe je via een link in onze e-mails.
                        </p>
    
                        <h2>Waar bewaren we die data?</h2>
                        <p>
                            Al onze data bewaren we in een optimaal beveiligde omgeving. 
                            Hierbij maken we gebruik van gespecialiseerde servers van Microsoft om de data in verschillende databanken te bewaren. 
                            De servers die Microsoft hiervoor gebruikt staan op twee verschillende locaties in Europa en zijn erg goed beveiligd.
                        </p>
    
                        <h2>Wie ontvangt mijn data?</h2>
                        <p>
                            Opdat we jouw onze diensten kunnen aanbieden, moeten we een aantal van jouw gegevens bekendmaken aan derden. 
        
                            We geven hieronder een overzicht: 
                            <ul>
                                <li>Cloud database services, zodat we jouw gegevens kunnen opslaan in erg beveiligde en versleutelde databanken.</li>
                                <br/>
                                <li>
                                    Aanbieders van diensten voor data analyse, omdat we verschillende tools gebruiken om gegevensanalyse in onze diensten te verbeteren. <br/>
                                    Daarnaast gebruiken we gegevensanalyse om challenges beter te maken en te beheren.
                                </li>
                            </ul>
                        </p>
    
                        <h2>Hoe lang verwerken we die data?</h2>
                        <p>
                            Zolang je gebruiker bent van onze App, verwerken we jouw data.
                            Ben je geen gebruiker meer, dan stoppen we met het verwerken van jouw persoonsgegevens. 
                            Je data wordt dan niet meer verwerkt in statistieken.
                        </p>
                        <p>
                            Kortom, we houden jouw persoonsgegevens niet langer bij dan nodig is om onze diensten aan jouw aan te bieden, 
                            tenzij we daar wettelijk toe verplicht zijn.
                        </p>
    
                        <h2>GDRP privacyrechten</h2>
                        <p>
                            In de GDPR wetgeving heb je een aantal rechten met betrekking tot privacy. 
                            Je hebt het recht om ons een verzoek te doen betreft inzage of rectificatie van jouw persoonsgegevens te verkrijgen, of om de verwerking van jouw persoonsgegevens te beperken. 
                            Daarnaast heb je ook het recht om bezwaar te maken tegen de verwerking van jouw persoonsgegevens. 
                            Daarenboven heb je het recht om jouw toestemming tot de verwerking van jouw persoonsgegevens ten allen tijde in te trekken. 
                            Jouw privacyrechten zijn voor ons een prioriteit en dit respecteren we.
                        </p>
                        <p>
                            Hou er wel rekening mee dat we onze diensten enkel kunnen aanbieden indien we jouw persoonsgegevens kunnen bewaren en verwerken. 
                            De functionaliteiten van onze App, zoals challenges en het aantal cases, zouden niet kunnen werken als we jouw data niet kunnen verwerken. 
                            Daarom is het belangrijk op te merken dat, indien je ons verzoekt om de verwerking van jouw persoonsgegevens te beperken of te beëindigen, we jammer genoeg onze betrekking zullen beëindigen.
                        </p>
    
                        <h2>Nog vragen?</h2>
                        <p>
                            Heb je vragen over jouw privacy of gerelateerde vragen rond jouw rechten? 
                            Dan mag je ze zeker stellen door een e-mail te sturen naar <a href="mailto:info@workerpro.be">info@workerpro.be</a>
                        </p>
                    </div>
                </div>
                
            </IonContent>
        </IonPage>
        );
    }
};

export default withRouter(PrivacyPolicy)
